/**
 * Draft デバイスカタログの Query Key Factory
 *
 * React Queryのキャッシュ管理に使用します。
 */
export const draftCatalogKey = {
  all: ['deviceCatalog', 'draft'] as const,
  detail: (id: string) => [...draftCatalogKey.all, 'detail', id] as const,
  header: (id: string) => [...draftCatalogKey.all, 'header', id] as const
} as const;